import React, { FC, useContext, useState } from 'react';
import { Button, Header }                  from 'semantic-ui-react';

import { HelpAndSupportStatement }         from '../../../../components/util/messaging/HelpAndSupportStatement';
import { DashboardProjectListItemContext } from './ProjectListItem';
import { SemanticUIColor }                 from '../../../../../types';

interface Props {}

const defaultProps: Props = {}

const ContinueInquiryMessage: FC<Props> = ( props ) => {
	
	let { operations } = useContext( DashboardProjectListItemContext );
	
	return (
		
		<>
			
			<Header textAlign={ 'center' } as={ 'h3' } content={ `Let's Get Started!` } color={ SemanticUIColor.PURPLE }/>
			
			<p className={ 'text-center margin-md-bottom' }>
				<strong>This project still needs more information from your team.</strong>
				<br/>
				Click "{ operations.continueInquiry.label }" to complete the initial survey.
				<br/>
				<br/>
				For assistance contact a
				{ ' ' }
				<HelpAndSupportStatement
					withInlineCasing={ true }
					withPreAmble={ false }
					contactName={ 'customer success representative' }
					withPostAmble={ false }
				/>.
			</p>
			
			<Button primary
			        onClick={ operations.continueInquiry.callback }
			        content={ operations.continueInquiry.label }/>
		
		</>
	
	);
};

ContinueInquiryMessage.defaultProps = defaultProps;

export { ContinueInquiryMessage }
